module.exports = __webpack_public_path__ + "static/media/vegetables_icon.677a2b3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vegetables_icon.svg
// module id = 155
// module chunks = 0